import React from "react";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosCall, IoMdMail } from "react-icons/io";

const Input = ({ type, placeholder, isLongText }) => {
  return (
    <>
      {isLongText ? (
        <textarea
          type="text"
          className="h-50 p-3 md:p-4 w-full rounded-md placeholder:font-light border bg-white shadow-md border-[#C7C7C7] placeholder:text-xs md:placeholder:text-base"
          placeholder={placeholder ?? ""}
          rows={3}
        />
      ) : (
        <input
          type={type ? type : "text"}
          className="h-50 p-3 md:p-4 w-full rounded-md placeholder:font-light border border-[#C7C7C7] placeholder:text-xs md:placeholder:text-base"
          placeholder={placeholder ?? ""}
        />
      )}
    </>
  );
};

const Btn = (props) => {
  const { title } = props;
  return (
    <div>
      <button
        className="rounded-md px-4 py-2 bg-[#16A951] flex items-center"
        aria-label={title}
      >
        <p className="font-normal text-white">{title}</p>
      </button>
    </div>
  );
};

const GetInTouch = () => {
  return (
    <div className="flex flex-col justify-center items-center bg-[#F8FCFA]">
      <div className="w-full px-6 xl:px-4 xl:w-2xl py-10 md:py-28 ">
        <div className="flex flex-col md:flex-row justify-between sm:px-2 md:px-0 md:items-center">
          <div className=" md:mb-0 " data-aos="fade-right">
            <div className="text-lg md:text-3xl font-semibold mb-1">
              Get in touch{" "}
            </div>
            {/* <div className="text-sm font-light mt-2 lg:mt-4">
              Here is the list of frequently asked questions about KAHA.
            </div> */}
            <div className="text-lg sm:text-xl font-medium sm:font-semibold mt-4 md:mt-14">
              Address
            </div>
            <div className=" flex  gap-1 sm:gap-3 mb-4 sm:mb-7 items-center text-xs  sm:text-lg ">
              <div className="text-[#16A951]">
                <FaLocationDot />
              </div>
              <div className="font-normal text-[#666666]">
                Anamnagar, Kathmandu Nepal
              </div>
            </div>
            <div className="text-lg sm:text-xl font-medium sm:font-semibold">
              Email
            </div>
            <div className=" flex  gap-1 sm:gap-3  mb-4 sm:mb-7  items-center text-xs  sm:text-lg ">
              <div className="text-[#16A951]">
                <IoMdMail />
              </div>
              <div className="font-normal text-[#666666] ">
                info@kaha.com.np{" "}
              </div>
            </div>
            <div className="text-lg sm:text-xl font-medium sm:font-semibold">
              Phone
            </div>
            <div className=" flex gap-1 sm:gap-3 mb-4 sm:mb-7  items-center text-xs  sm:text-lg ">
              <div className="text-[#16A951]">
                <IoIosCall />
              </div>
              <div className="font-normal text-[#666666]">
                +977 9801845410, +977 1-5907701{" "}
              </div>
            </div>
            
            {/* Social Media Links */}
            <div className="text-lg sm:text-xl font-medium sm:font-semibold mt-6 mb-4">
              Follow Us
            </div>
            <div className="flex gap-3 mb-6">
              <a
                href="https://www.facebook.com/KAHAINC"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#16A951] hover:text-[#128a3d] transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/kahaapp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#16A951] hover:text-[#128a3d] transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/kahaapp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#16A951] hover:text-[#128a3d] transition-colors"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/2" data-aos="fade-left">
            <div className=" lg:mt-9 flex flex-col gap-2 sm:gap-4">
              <div className="flex gap-2 md:gap-8 flex-col md:flex-row ">
                <div className="flex-1">
                  <Input placeholder="Full Name" />
                </div>
                <div className="flex-1">
                  <Input placeholder="Email" />
                </div>
              </div>
              <div className="flex gap-2 md:gap-8 flex-col md:flex-row ">
                <div className="flex-1">
                  <Input placeholder="Phone Number" />
                </div>
                <div className="flex-1">
                  <Input placeholder="Company Name" />
                </div>
              </div>
              <div className="">
                <Input isLongText="true" placeholder="Message" />
              </div>
            </div>
            <div className="mt-2 md:mt-6 flex justify-end md:justify-start w-full">
              <Btn title="Send Message" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
